import { useRef } from 'react';
import { useRouter } from 'next/router';
import { useLocale } from '@/context/LocaleContext';
import Form from './Form';
import Image from 'next/image';
import LittleRedLine from '@/components/LittleRedLine';
import TituloH2 from '@/components/TitulosTextos/H2';


const Hero = ({ dict, initialPartner = 'Sin referido', campaign = '' }) => {
  const section = useRef(null);
  const router = useRouter();
  const locale = useLocale();
  const isBeneficioPunto = campaign === 'BENEFICIO_PUNTO';

  return (
    <section
      ref={section}
      className="site-max relative w-full pt-145 pb-100 sm:pb-40 overflow-hidden"
    >
      <div className="site-grid grid grid-cols-1 lg:grid-cols-12 gap-6">
        {/* Contenedor del texto */}
        <div className="lg:col-span-7 flex flex-col sm:flex-row items-start sm:items-center">
          <div className="pt-44 mb-50 sm:mb-0">
            <TituloH2
              classes="title-3 text-cyan-dark my-30"
              text={
                isBeneficioPunto ? (
                  <>Ya sos punto, sumate como cliente</>
                ) : (
                  <>Hacelo simple: Sumá HOP</>
                )
              }
            />
            <LittleRedLine />
            <p className="p1 text-black-1 opacity-60 my-30">
              {isBeneficioPunto
                ? 'Completá el formulario y accede a un 10% de descuento en tu 1er mes de facturación si nos sumas como medio de envío en tu tienda de ecommerce.'
                : 'Despachá y entregá tus pedidos en nuestros puntos HOP en todo el país.'}
            </p>
            <Form
              dict={dict}
              partner={initialPartner}
              campaign={campaign}
              finish={() =>
                router.push(
                  {
                    pathname: '/gracias-partner',
                    query: campaign ? { campaign } : undefined
                  },
                  undefined,
                  { locale }
                )
              }
            />
          </div>
        </div>

        {/* Contenedor de la imagen */}
        <div className="lg:col-span-5 flex justify-center items-center relative">
          <Image
            src="/images/referidos/woman.svg"
            width={465}
            height={525}
            alt=""
            className="max-w-full max-h-full object-contain"
          />
        </div>
      </div>
    </section>
  );
};
export default Hero;
